/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * * `user-text` - USER_TEXT
 * * `assistant-text` - ASSISTANT_TEXT
 * * `draft` - DRAFT
 * * `tool-call` - TOOL_CALL
 * * `tool-result` - TOOL_RESULT
 * * `tool-error` - TOOL_ERROR
 * * `thinking` - THINKING
 * * `member-added` - MEMBER_ADDED
 * * `member-removed` - MEMBER_REMOVED
 * * `retry-prompt` - RETRY_PROMPT
 * * `system-prompt` - SYSTEM_PROMPT
 * * `user-prompt` - USER_PROMPT
 */
export enum ChatMessageKind {
  USER_TEXT = 'user-text',
  ASSISTANT_TEXT = 'assistant-text',
  DRAFT = 'draft',
  TOOL_CALL = 'tool-call',
  TOOL_RESULT = 'tool-result',
  TOOL_ERROR = 'tool-error',
  THINKING = 'thinking',
  MEMBER_ADDED = 'member-added',
  MEMBER_REMOVED = 'member-removed',
  RETRY_PROMPT = 'retry-prompt',
  SYSTEM_PROMPT = 'system-prompt',
  USER_PROMPT = 'user-prompt',
}
